import { WindRichtlinienab } from "../ws/wind-richtlinienab.model";

export class UserWindRichtlinienab   {
  idUserWindRichtlinenab: number;
  windrichtung: number;
  windhaeufigkeit: number;
  idGebietskategorie: number;
  hg: number;
 

  constructor(windRichtlinienab: WindRichtlinienab)
  {
    this.windrichtung = windRichtlinienab.windrichtung;
    this.windhaeufigkeit = 0;
    this.idGebietskategorie = windRichtlinienab.idGebietskategorie;
    this.hg = 0;
  }
}
